import React from 'react';

import { get } from 'lodash';
import axios from 'axios';
import { toast } from 'react-toastify';

import { API_HOST } from '../../consts';
import { Form } from 'informed';
import { withRouter } from 'react-router-dom';
import FormContainer from '../../containers/Form';
import InputSelect from '../../components/inputs/InputSelect';
import LabelView from '../../components/LabelView';

class IntegracaoTOTVS extends React.Component {
  state = {
    avaliacao: undefined,
    avaliacoes: [],
    cursos: [],
    cursoAtual: [],
    disciplinas: [],
    cursosAtual: null,
    disciplinaAtual: null,
    integracaoPayload: null
  };

  fetchCursos = () => {
    axios
      .get(
        `${API_HOST}/avaliacoes/avaliacao/get_cursos_from_totvs_distinct_period`
      )
      .then((res) => {
        this.setState({ cursos: res.data });
      })
      .catch((err) => {
        toast.error('Ocorreu um erro');
        console.error(err);
      });
  };

  fetchAvaliacao = () => {
    const { match } = this.props;

    axios
      .get(`${API_HOST}/avaliacoes/avaliacao/${match.params.id}`)
      .then((res) => {
        this.setState({ avaliacao: res.data }, this.setInitialValues);
      })
      .catch((err) => {
        toast.error('Ocorreu um erro');
        console.error(err);
      });
  };

  fetchDisciplinas = (curso) => {
    const { cursoAtual } = this.state;

    if (
      cursoAtual &&
      get(cursoAtual, 'descricao') !== get(curso, 'descricao')
    ) {
      this.formApi.setValue('avaliacoes', null);
      this.formApi.setValue('disciplina', null);
    }
    if (curso) {
      axios
        .get(
          `${API_HOST}/avaliacoes/avaliacao/get_disciplinas_from_totvs?curso=${curso.descricao}`
        )
        .then((res) => {
          this.setState({ disciplinas: res.data, cursoAtual: curso });
        })
        .catch((err) => {
          toast.error('Ocorreu um erro, tente novamente.');
          console.error(err);
        });
    }
  };

  fetchAvaliacoes = (idDisciplina) => {
    const { cursoAtual, disciplinaAtual } = this.state;

    if (
      disciplinaAtual &&
      get(disciplinaAtual, 'descricao') !== get(idDisciplina, 'descricao')
    ) {
      this.formApi.setValue('avaliacoes', null);
    }

    if (idDisciplina) {
      axios
        .get(
          `${API_HOST}/avaliacoes/avaliacao/get_avaliacoes_from_totvs?curso=${cursoAtual.descricao}&id_disciplina=${idDisciplina.descricao}`
        )
        .then((res) => {
          this.setState({
            avaliacoes: res.data,
            disciplinaAtual: idDisciplina
          });
        })
        .catch((err) => {
          toast.error('Ocorreu um erro, tente novamente.');
          console.error(err);
        });
    }
  };

  setInitialValues = () => {
    const initialValues = this.formatInitialValues();
    this.formApi.setValues(initialValues);
  };

  componentDidMount() {
    Promise.all([this.fetchCursos(), this.fetchAvaliacao()]);
  }

  formatIntegracaoPayload = () => {
    const { cursoAtual, disciplinaAtual, avaliacaoAtual } = this.state;

    console.log(disciplinaAtual);
    return JSON.stringify({
      curso: cursoAtual.descricao,
      disciplina: disciplinaAtual.label,
      id_disciplina: disciplinaAtual.descricao,
      avaliacao: avaliacaoAtual.descricao
    });
  };

  handleUpdateAvaliacao = () => {
    const { match } = this.props;
    const integracaoPayload = this.formatIntegracaoPayload();

    axios
      .patch(
        `${API_HOST}/avaliacoes/avaliacao/${match.params.id}/update_integracao_field`,
        {
          integracaoPayload
        }
      )
      .then((res) => {
        console.log(res);
        const { history } = this.props;
        history.push('/instrumentos-cognitivos');
      })
      .catch((err) => {
        const status = get(err, 'response.status');
        if (status === 404) {
          toast.error(
            'Para finalizar, é necessário selecionar os 3 campos (Curso, Disciplina e Avaliação).'
          );
        } else {
          toast.error('Ocorreu um erro, tente novamente.');
        }
        console.error(err);
      });
  };

  formatInitialValues = () => {
    const { avaliacao } = this.state;

    const rawIntegracaoTotvs = JSON.parse(
      get(avaliacao, 'integracao_totvs', '{}')
    );

    const curso = get(rawIntegracaoTotvs, 'curso')
      ? {
          id: get(rawIntegracaoTotvs, 'curso'),
          value: get(rawIntegracaoTotvs, 'curso'),
          label: get(rawIntegracaoTotvs, 'curso'),
          descricao: get(rawIntegracaoTotvs, 'curso')
        }
      : undefined;

    const disciplina = get(rawIntegracaoTotvs, 'disciplina')
      ? {
          id: get(rawIntegracaoTotvs, 'disciplina'),
          idDisciplina: get(rawIntegracaoTotvs, 'id_disciplina'),
          value: get(rawIntegracaoTotvs, 'disciplina'),
          label: get(rawIntegracaoTotvs, 'disciplina'),
          descricao: get(rawIntegracaoTotvs, 'id_disciplina')
        }
      : undefined;

    const avaliacoes = get(rawIntegracaoTotvs, 'avaliacao')
      ? {
          id: get(rawIntegracaoTotvs, 'avaliacao'),
          value: get(rawIntegracaoTotvs, 'avaliacao'),
          label: get(rawIntegracaoTotvs, 'avaliacao'),
          descricao: get(rawIntegracaoTotvs, 'avaliacao')
        }
      : undefined;

    this.setState(
      {
        cursoAtual: curso,
        disciplinaAtual: disciplina,
        avaliacaoAtual: avaliacoes
      },
      () => {
        if (curso) {
          this.fetchDisciplinas(curso);
        }

        if (disciplina) {
          this.fetchAvaliacoes(disciplina);
        }
      }
    );

    return {
      curso,
      disciplina,
      avaliacoes
    };
  };

  render() {
    const { avaliacoes, cursos, disciplinas, avaliacao } = this.state;

    return (
      <Form
        getApi={(formApi) => {
          this.formApi = formApi;
        }}
      >
        <FormContainer
          title="Integração TOTVS"
          previous="itens"
          onClick={this.handleUpdateAvaliacao}
          last="instrumentos-cognitivos"
        >
          <div className="row">
            <LabelView
              col="col-sm-6"
              title="Avaliação"
              text={get(avaliacao, 'nome')}
            />
            <LabelView
              col="col-sm-6"
              title="Número de Itens"
              text={get(avaliacao, 'itens')}
            />
          </div>
          <div className="row" style={{ marginBottom: '1.5rem' }}>
            <InputSelect
              label="Curso"
              col="col-md-4"
              field="curso"
              onChange={this.fetchDisciplinas}
              options={cursos}
            />
            <InputSelect
              label="Disciplina"
              col="col-md-4"
              field="disciplina"
              onChange={this.fetchAvaliacoes}
              options={disciplinas}
            />
            <InputSelect
              label="Avaliação"
              col="col-md-4"
              field="avaliacoes"
              onChange={(avaliacaoAtual) => this.setState({ avaliacaoAtual })}
              options={avaliacoes}
            />
          </div>
        </FormContainer>
      </Form>
    );
  }
}

export default withRouter(IntegracaoTOTVS);
